import api from './api';
import photoService from './photoService';

/**
 * Serviço de notas/fichas de Person + anexos.
 * Fluxo de anexo em 2 passos (igual à foto): sobe o binário no FileService (api/files),
 * depois registra o metadado na API (que mede o uso). O r2Key é derivado do path da URL
 * devolvida pelo FileService — robusto a qualquer sanitização do nome no servidor.
 */
const personNotesService = {
  // ── Notas ──────────────────────────────────────────────────────────────────
  list: async (personId) => {
    const { data } = await api.get(`/persons/${personId}/notes`);
    return data;
  },

  create: async (personId, payload) => {
    const { data } = await api.post(`/persons/${personId}/notes`, payload);
    return data;
  },

  update: async (personId, noteId, payload) => {
    const { data } = await api.put(`/persons/${personId}/notes/${noteId}`, payload);
    return data;
  },

  remove: async (personId, noteId) => {
    await api.delete(`/persons/${personId}/notes/${noteId}`);
  },

  // ── Anexos ───────────────────────────────────────────────────────────────────
  /**
   * Sobe o arquivo no FileService e registra o metadado na API.
   * @returns {Promise<Object>} PersonNoteAttachmentDto { id, fileName, url, contentType, byteSize, kind, createdAt }
   */
  uploadAndAttach: async (personId, noteId, file) => {
    const uploaded = await photoService.uploadNoteAttachment(file, noteId);

    // Deriva a chave do bucket a partir do path da URL do CDN (ex.: person-note/{noteId}/{nome}).
    let r2Key;
    try {
      r2Key = new URL(uploaded.fileUrl).pathname.replace(/^\/+/, '');
    } catch {
      r2Key = `person-note/${noteId}/${uploaded.originalFileName}`;
    }

    const { data } = await api.post(`/persons/${personId}/notes/${noteId}/attachments`, {
      fileName: uploaded.originalFileName,
      r2Key,
      contentType: uploaded.contentType,
      byteSize: uploaded.processedFileSize ?? uploaded.originalFileSize,
    });
    return data;
  },

  removeAttachment: async (personId, noteId, attachmentId) => {
    await api.delete(`/persons/${personId}/notes/${noteId}/attachments/${attachmentId}`);
  },
};

export default personNotesService;
